export const meta = { id: 'O33', slug: 'conclusao-formacao', title: 'Como funciona a conclusão da Formação', description: 'Entenda como Componentes obrigatórios determinam a conclusão e como opcionais se comportam.', profile: 'owner', category: 'formacoes', type: 'concept', status: 'published', order: 630, keywords: ['conclusão','formação','obrigatório','opcional','progresso'], previous: 'O32', next: 'O34', related: ['O28','O32','A13.1'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como funciona a conclusão da Formação

A Formação é concluída quando todos os Componentes obrigatórios necessários foram atendidos conforme as regras configuradas.

## Regras centrais

- Componentes obrigatórios participam da conclusão;
- Componentes opcionais não bloqueiam a conclusão;
- Treinamentos vinculados podem depender do progresso real das Aulas;
- pré-requisitos controlam a liberação do percurso, mas não substituem a regra de conclusão.

<HelpImage pendingId="O32.1" alt="Participante com Formação concluída" />

<Callout type="important">A versão atual não possui certificado de Formação. Não comunique certificado como parte da experiência existente.</Callout>
